export function getCookie(key: string, req?: any) {
  if (typeof window === 'undefined') {
    // Server-side
    if (!req?.headers?.cookie) {
      // 'No request object or headers found';
      return null;
    }
    const maybeRow = req.headers.cookie.split('; ').find((row) => row.startsWith(key + '='));
    if (!maybeRow) {
      return null;
    }
    return maybeRow.split('=')[1];
  } else {
    // Client-side
    const maybeRow = document.cookie.split('; ').find((row) => row.startsWith(key + '='));
    if (!maybeRow) {
      return null;
    }
    return maybeRow.split('=')[1];
  }
}

export function setCookie(key: string, value: string, options = {}) {
  let updatedCookie = encodeURIComponent(key) + '=' + encodeURIComponent(value);
  for (const optionKey in options) {
    updatedCookie += '; ' + optionKey;
    const optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += '=' + optionValue;
    }
  }
  document.cookie = updatedCookie;
}

export function clearAllCookies(): void {
  const cookies: string[] = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const cookie: string = cookies[i];
    const eqPos: number = cookie.indexOf('=');
    const name: string = eqPos > -1 ? cookie.slice(0, eqPos) : cookie.trim();
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  }
}
